import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-bone">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="kbd text-white/50">DR TEGBIR VASCULAR</div>
            <h2 className="mt-6 font-serif text-4xl md:text-6xl tracking-tightest leading-[1.02]">
              Continuity<br/>from first call<br/>to final follow-up.
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-flex items-center gap-3 mt-10 text-[13px] tracking-wide border border-white/30 rounded-full px-6 py-3 hover:bg-bone hover:text-ink transition-colors"
            >
              Book a consultation
              <span aria-hidden>↗</span>
            </Link>
          </div>
          <div className="md:col-span-3 space-y-4">
            <div className="kbd text-white/50">Clinic</div>
            <p className="text-sm text-white/80 leading-relaxed">
              Max Super Speciality Hospital<br/>
              Mohali, Punjab, India
            </p>
            <p className="text-xs text-white/50 mt-4 flex items-start gap-2"><MapPin size={12} className="mt-0.5" /> Vascular & Endovascular IR Suite</p>
          </div>
          <div className="md:col-span-3 space-y-4">
            <div className="kbd text-white/50">Contact</div>
            <a href={WHATSAPP_LINK("Hello Dr Sidhu, I'd like to enquire about a consultation.")} target="_blank" rel="noreferrer" className="block text-sm text-white/80 hover:text-white" data-testid="footer-whatsapp">
              <span className="inline-flex items-center gap-2"><Phone size={12}/> +91 96460 00444</span>
            </a>
            <a href="mailto:tegbirsidhu@gmail.com" className="block text-sm text-white/80 hover:text-white">
              <span className="inline-flex items-center gap-2"><Mail size={12}/> tegbirsidhu@gmail.com</span>
            </a>
            <div className="flex gap-3 mt-6 flex-wrap">
              {["ISVIR","CIRSE","IRIA","PMC","MCI"].map((c) => (
                <span key={c} className="kbd border border-white/20 rounded-full px-2.5 py-1">{c}</span>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Dr Tegbir Singh Sidhu. All rights reserved.</div>
          <div className="flex gap-6 flex-wrap">
            <a href="https://share.google/5uMOY8s6W2EyQ4E24" target="_blank" rel="noreferrer" data-testid="footer-gbp-link" className="hover:text-white">Google reviews</a>
            <Link to="/journal" data-testid="footer-journal-link" className="hover:text-white">Journal</Link>
            <Link to="/second-opinion" data-testid="footer-second-opinion-link" className="hover:text-white">Second opinion</Link>
            <Link to="/cities" data-testid="footer-regions-link" className="hover:text-white">Regions</Link>
            <Link to="/nri" className="hover:text-white">For NRI</Link>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
